import { keyBy } from '@freelancer/utils';
import type * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Convert a list into a map.
 */
export function asObject<
  T extends { readonly id: K },
  K extends string | number,
>(): (
  list$: Rx.Observable<readonly T[]>,
) => Rx.Observable<{ readonly [id: string]: T }> {
  return map(list => keyBy(list, item => item.id));
}
